import React from 'react';
import { Link } from 'react-router-dom';
import { GovCard, GovFlex, GovIcon } from '@gov-design-system-ce/react';
import { useExtraConfigContext } from '@gov-nx/core/app';
import { useConfiguration, useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { Button, LayoutGap } from '@gov-nx/ui/web';
import { MarkdownRender } from '../../Markdown/MarkdownRender';

export interface UserManualViewProps {
	code: PageCode;
}

export const UserManualView = ({ code }: UserManualViewProps) => {
	const { extraConfig } = useExtraConfigContext();
	const { handbookDesktopUrl, handbookMobileUrl } = useConfiguration();
	const { t } = useLocale(code);

	return (
		<LayoutGap gap="xl">
			<GovCard
				direction="horizontal"
				icon={
					<GovIcon
						slot="icon"
						type="complex"
						name="portal"
					/>
				}>
				<GovFlex
					direction="column"
					gap="s">
					<h2 className="text-headline-s! text-(--text-primary-color)">
						{t('uzivatelska-prirucka.pocitac.nadpis')}
					</h2>
					<p className="mt-0!">{t('uzivatelska-prirucka.pocitac.popis')}</p>
					{handbookDesktopUrl ? (
						<Button
							asChild
							color="primary"
							type="outlined"
							size="s"
							isExpandedMobile
							aria-label={t('uzivatelska-prirucka.tlacitko.wcag.pocitac')}
							className="my-2!">
							<Link
								target="_blank"
								to={handbookDesktopUrl}>
								{t('uzivatelska-prirucka.tlacitko.text')}
							</Link>
						</Button>
					) : null}
				</GovFlex>
			</GovCard>

			{extraConfig.pageRoutes.userManualConfig.showMobileManual && (
				<GovCard
					direction="horizontal"
					icon={
						<GovIcon
							slot="icon"
							type="complex"
							name="mobile-phone"
						/>
					}>
					<GovFlex
						direction="column"
						gap="s">
						<h2 className="text-headline-s! text-(--text-primary-color)">
							{t('uzivatelska-prirucka.mobil.nadpis')}
						</h2>
						<MarkdownRender>
							{t('uzivatelska-prirucka.mobil.popis')}
						</MarkdownRender>
						{handbookMobileUrl ? (
							<Button
								asChild
								color="primary"
								type="outlined"
								size="s"
								isExpandedMobile
								aria-label={t('uzivatelska-prirucka.tlacitko.wcag.mobil')}
								className="my-2!">
								<Link
									target="_blank"
									to={handbookMobileUrl}>
									{t('uzivatelska-prirucka.tlacitko.text')}
								</Link>
							</Button>
						) : null}
					</GovFlex>
				</GovCard>
			)}
		</LayoutGap>
	);
};
